// src/utils/apiError.js

export function getMensagemErroApi(err, mensagemPadrao) {
    if (!mensagemPadrao) {
      mensagemPadrao = 'Erro ao processar a operação.';
    }
  
    var data = err && err.response ? err.response.data : null;
  
    if (data && data.mensagens && data.mensagens.length > 0) {
      return data.mensagens[0].descricao;
    }
  
    if (data && data.message) {
      return data.message;
    }
  
    if (err && err.message) {
      return err.message;
    }
  
    return mensagemPadrao;
  }
  
  export function tratarErroApi(err, options) {
    options = options || {};
  
    var toastFn = options.toast || null;
    var mostrarToast = options.mostrarToast !== false;
    var onErro = options.onErro || null;
    var mensagemPadrao = options.mensagemPadrao || 'Erro ao processar a operação.';
  
    var data = err && err.response ? err.response.data : null;
    var mensagem = getMensagemErroApi(err, mensagemPadrao);
  
    // 👉 usa o toast vindo do componente
    if (mostrarToast && typeof toastFn === 'function') {
      toastFn(mensagem, 'Falha', 'danger');
    }
  
    if (typeof onErro === 'function') {
      onErro(data, err);
    }
  
    return data;
  }